import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import PersonnelIdentityContext from "src/contexts/data/PersonnelIdentityContext";
import useCurrentUser from "src/hooks/authentication/useCurrentUser";
import { createPersonnelSubMenu } from "src/routing/navigation";

/**
 * Registers the personnel submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation.
 */
const PersonnelSubMenu: React.FC = () => {
    const { data: personnelIdentity } = useContext(PersonnelIdentityContext);
    const currentUser = useCurrentUser();

    const subMenu = useMemo(() => {
        if (!personnelIdentity) {
            return null;
        }

        return createPersonnelSubMenu(personnelIdentity, currentUser?.username);
    }, [currentUser?.username, personnelIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default PersonnelSubMenu;
